import React, { useState, useEffect } from 'react';
import './tutorialtroublesooting.scss';
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import { useNavigate } from "react-router-dom";
import { tutorialListAction, deleteContentAction, getContentDetails } from '../../actions/trainingModuleAction';
import { useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import ConfirmationPopup from "../../component/ConfirmationPopup";
import { encode } from "base-64";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { AiOutlineClose } from "react-icons/ai";
import { constant } from '../../constants/constant';
import { HTTP_STATUS } from '../../constants/httpsStatus/httpsStatus';
import useMobileView from "../../constants/useMobileView";
import { is2w } from '../../constants/vehicleTypeHelper';
import { notify } from '../../services/notification';

const TutorialTroublesooting = () => {
  const twoW = is2w();

  const [searchInput, setSearchInput] = useState('');
  const [searchTutorial, setSearchTutorial] = useState('');
  const [activeTab, setActiveTab] = useState(twoW ? 'training' : 'tutorial');
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const [tutorialList, SettutorialList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(
    twoW
      ? { all: true, manual: false, training: false, troubleshooting: false, info_bulletin: false }
      : { all: true, tutorial: false, troubleshooting: false }
  );
  const [paginationListcount, setpaginationListcount] = useState(0);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [selectedType, setSelectedType] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const listAction = tutorialListAction;

  const FILTER_TYPE_MAP = twoW
    ? { manual: 'manual', training: 'training', troubleshooting: 'trouble_shooting', info_bulletin: 'info_bulletin' }
    : { tutorial: 'tutorial', troubleshooting: 'trouble_shooting' };

  const getTypeFromFilters = (filters) => {
    for (const [key, type] of Object.entries(FILTER_TYPE_MAP)) {
      if (filters[key]) return type;
    }
    return '';
  };

  const handleFilterChange = (filter) => {
    setPage(1);
    const filterKeys = Object.keys(FILTER_TYPE_MAP);
    const newFilters = { all: filter === 'all' };
    filterKeys.forEach(key => { newFilters[key] = filter === key; });
    setSelectedFilters(newFilters);
    setSelectedType(FILTER_TYPE_MAP[filter] || '');
  };

  const fetchTutorialList = async (pageNumber = page, type = selectedType) => {
    setIsLoading(true);
    const newStartIndex = (pageNumber - 1) * 10 + 1;
    setStartIndex(newStartIndex);
    let response = await dispatch(listAction(pageNumber, searchTutorial, type));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      SettutorialList(response?.data?.data?.results);
      setpaginationListcount(response?.data?.data?.count);
      setCount(Math.ceil(response?.data?.data?.count / constant.paginationCount));
    }
    setIsLoading(false);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleTabChange = (tab, route) => {
    setActiveTab(tab);
    navigate(route);
  };

  const updateTutorial = (id) => {
    window.scroll(0, 0);
    const encodeid = encode(id);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.trimStart();
    setSearchInput(value);

    if (value === '') {
      setSearchTutorial('');
    }
  };

  const handleSearch = () => {
    setPage(1);
    setSearchTutorial(searchInput);
  };

  // 2W-specific handlers

  useEffect(() => {
    const newStartIndex = (page - 1) * 10 + 1;
    setStartIndex(newStartIndex);
    setIsLoading(true);
    dispatch(listAction(page, searchTutorial, selectedType))
      .then((response) => {
        if (response?.status === HTTP_STATUS.SUCCESS) {
          const searchResults = response?.data?.data?.results || [];
          SettutorialList(searchResults);
          setpaginationListcount(response?.data?.data?.count || 0);
          setCount(Math.ceil((response?.data?.data?.count || 0) / constant.paginationCount));
        } else {
          SettutorialList([]);
          setpaginationListcount(0);
          setCount(0);
        }
      })
      .finally(() => setIsLoading(false));
  }, [page, searchTutorial, selectedType]);

  const startItem = tutorialList?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  // Route paths
  const contentListPath = twoW ? '/2w/training/list' : '/training/tutorialtroubleshooting';
  const moduleListPath = twoW ? '/2w/training/modules/list' : '/training/modules/list';
  const addContentPath = twoW ? '/2w/training/addcontent' : '/training/addcontent';

  return (
    <div className={twoW ? "tutorial-page-container-2w" : "tutorial-page-container"}>
      <div className="tutorial-content-wrapper">
        <Header title={twoW ? "Training & Service" : "Tutorial And Troubleshooting"} />
        <div className="tutorial-section">
          <div className="training-tutorial-troubles-panel">
            <div className="tutorial-nav-buttons">
              <div style={{ display: "flex", gap: "1rem" }}>
                <button
                  className={`tutorial-nav-btn ${activeTab === (twoW ? 'training' : 'tutorial') ? 'active' : ''}`}
                  onClick={() => handleTabChange(twoW ? 'training' : 'tutorial', contentListPath)}
                >
                  {twoW ? 'Training & Service' : 'Tutorial and Troubleshooting'}
                </button>
                <button
                  className={`tutorial-nav-btn ${activeTab === 'module' ? 'active' : ''}`}
                  onClick={() => handleTabChange('module', moduleListPath)}
                >
                  Module
                </button>
              </div>
              <button
                className="tutorial-add-btn"
                onClick={() => navigate(addContentPath)}
              >
                Add Content
              </button>
            </div>

            <div className="tutorial-filters">
              <div className="tutorial-checkbox-group">
                <div className='tutorial-checkbox'>
                  <label className="tutorial-checkbox-label">
                    <input
                      type="checkbox"
                      checked={selectedFilters.all}
                      onChange={() => handleFilterChange('all')}
                    />
                    <span>All</span>
                  </label>
                  {twoW ? (
                    <>
                      <label className="tutorial-checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedFilters.manual}
                          onChange={() => handleFilterChange('manual')}
                        />
                        <span>Manual</span>
                      </label>
                      <label className="tutorial-checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedFilters.training}
                          onChange={() => handleFilterChange('training')}
                        />
                        <span>Training</span>
                      </label>
                      <label className="tutorial-checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedFilters.troubleshooting}
                          onChange={() => handleFilterChange('troubleshooting')}
                        />
                        <span>Troubleshooting</span>
                      </label>
                      <label className="tutorial-checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedFilters.info_bulletin}
                          onChange={() => handleFilterChange('info_bulletin')}
                        />
                        <span>Info Bulletin</span>
                      </label>
                    </>
                  ) : (
                    <>
                      <label className="tutorial-checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedFilters.tutorial}
                          onChange={() => handleFilterChange('tutorial')}
                        />
                        <span>Tutorial</span>
                      </label>
                      <label className="tutorial-checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedFilters.troubleshooting}
                          onChange={() => handleFilterChange('troubleshooting')}
                        />
                        <span>Troubleshooting</span>
                      </label>
                    </>
                  )}
                </div>
                <div className="tutorial-search-button">
                  <input
                    type="text"
                    placeholder="Search"
                    className="tutorial-search-input"
                    value={searchInput}
                    onChange={handleSearchChange}
                  />
                  <button className="tutorial-search-btn" onClick={handleSearch}>Search</button>
                </div>
              </div>
            </div>
            <div className="tutorial-table-container">
              <div className="tutorial-table-data">
                <table className="table">
                  <thead>
                    <tr className="tablesth">
                      <th className='tablesth'>S.No.</th>
                      <th className='tablesth'>Heading</th>
                      <th className='tablesth'>Description</th>
                      {twoW && <th className='tablesth'>Category</th>}
                      <th className='tablesth'>Vehicle</th>
                      <th className='tablesth'>Date</th>
                      <th className='tablesth'>Type</th>
                      <th className='tablesth'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tutorialList?.length > 0 ? (
                      tutorialList?.map((item, index) => (
                        <tr key={item.id}>
                          <td className='tabletd'>{index + startIndex}</td>
                          <td className='tabletd long-text' title={item?.title}>{item.title}</td>
                          <td className='tabletd long-text' title={item?.description}>{item.description}</td>
                          {twoW && <td className='tabletd'>{item?.training_category || 'N/A'}</td>}
                          <td className='tabletd long-text' title={item.vehicle_list?.map((vehicle) => vehicle.name).join(', ')}>{item.vehicle_list?.map((vehicle) => vehicle.name).join(', ')}</td>
                          <td className='tabletd'>
                            {item?.created_at
                              ? new Date(item?.created_at).toLocaleDateString()
                              : "N/A"}
                          </td>
                          <td className='tabletd'>{item.type}</td>
                          <td className={twoW ? "action-icons-cell" : ""}>
                            <img
                              src={Image_Url.EDIT}
                              className="training-editicons"
                              alt="Edit Icon"
                              onClick={() => {
                                navigate(`${addContentPath}/?id=${item?.id}`);
                                updateTutorial(item?.id);
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={twoW ? "8" : "7"}>
                          <NoDataFound />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="Pagination_section">
              {tutorialList?.length > 0 && (
                <Stack spacing={2}>
                  <Pagination
                    count={count}
                    className="pagination"
                    page={page}
                    size="medium"
                    defaultPage={1}
                    color="primary"
                    onChange={handlePageChange}
                  />
                </Stack>
              )}
              <div className="count">
                <b>
                  <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorialTroublesooting;
